var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"p-0 m-0",style:('font-family: ' + _vm.font),attrs:{"fluid":""}},[_c('router-view',{key:_vm.$route.path}),_c('Snackbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }